export const  SET_CURRENT_USER = 'SET_CURRENT_USER';
export const  DELETE_CURRENT_USER = 'DELETE_CURRENT_USER';
export const  SET_CURRENT_USER_AUTHORISATION = 'SET_CURRENT_USER_AUTHORISATION';
